/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
require('flickity-imagesloaded');

export function gallerySlider() {
  var slider = document.querySelector('.gallery__slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    freeScroll: true,
    pageDots: false,
    adaptiveHeight: false,
    imagesLoaded: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var tapArea, startX;
  tapArea = document.querySelectorAll('.gallery__slider');
  startX = 0;
  for (var item of tapArea) {
    item.ontouchstart = function (e) {
      startX = e.touches[0].clientX;
    };
    item.ontouchmove = function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
        e.preventDefault();
      }
    };
  }
}
